// Dispatcher für Ergebnis-Reports — wählt das passende Result-Layout je Survey-Slug.
import { useEffect, useState } from 'react'
import { useParams, Link } from 'react-router-dom'
import { api } from '../lib/api.js'
import MiWayResult from './MiWayResult.jsx'
import MyCultureResult from './MyCultureResult.jsx'
import ProResResult from './ProResResult.jsx'
import { AlertCircle } from 'lucide-react'

export default function Result() {
  const { accessId } = useParams()
  const [state, setState] = useState({ loading: true, slug: null, error: null })

  useEffect(() => {
    let cancelled = false
    api.myResponses()
      .then(items => {
        if (cancelled) return
        const item = items.find(i => i.accessId === accessId)
        if (!item) return setState({ loading: false, error: 'Ergebnis nicht gefunden.' })
        setState({ loading: false, slug: item.survey.slug })
      })
      .catch(e => !cancelled && setState({ loading: false, error: e.message }))
    return () => { cancelled = true }
  }, [accessId])

  if (state.loading) return <div className="text-ink-soft">Lade Ergebnis…</div>
  if (state.error) return (
    <div className="max-w-2xl mx-auto card p-8 text-center">
      <AlertCircle className="mx-auto text-amber-500 mb-3" size={32} />
      <p className="text-ink-soft mb-4">{state.error}</p>
      <Link to="/" className="btn-secondary">Zurück zur Übersicht</Link>
    </div>
  )
  if (state.slug === 'miway-4') return <MiWayResult />
  if (state.slug === 'myculture-pref') return <MyCultureResult />
  if (state.slug === 'prores-2-5') return <ProResResult />
  return (
    <div className="max-w-2xl mx-auto card p-8 text-center text-ink-soft">
      Kein Ergebnis-Layout für diese Umfrage vorhanden.
    </div>
  )
}
